// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"ccc64bd9","431":"6b677263","689":"cffed08f","768":"d8e14136"}[chunkId] + ".chunk.js";
};